import LpPublicPassport from '@liepin/publicLogin';

const lpLogin = new LpPublicPassport({
  tenantId: 'liepin',
  businessId: '1100100012',
});

export function loginByTel({ tel, smsCode, ...args }) {
  return new Promise((resolve, reject) => {
    lpLogin.sendRequest({
      requestType: 'mobileLogin',
      requestData: {
        tel,
        smsCode,
        ...args,
      },
      success({ flag, data, ...err }) {
        if (flag === 1) {
          resolve(data);
        } else {
          reject(err || {});
        }
      },
      cancel() {
        reject({});
      },
      error({ type, err: msg }) {
        reject({ type, msg });
      },
    });
  });
}

export function loginByAccount({ login, pwd, ...args }) {
  return new Promise((resolve, reject) => {
    lpLogin.sendCaptchaRequest({
      requestType: 'accountLogin',
      requestData: {
        login,
        pwd,
        businessId: '1100100017',
        ...args,
      },
      success({ flag, data, ...err }) {
        if (flag === 1) {
          resolve(data);
        } else {
          reject(err || {});
        }
      },
      cancel() {
        reject({});
      },
      error({ type, err: msg }) {
        reject({ type, msg });
      },
    });
  });
}

/**
 * 不同的场景发送手机号验证码时需要传入不同的 businessId
 * 各种场景的businessId如下:
 * 默认是登录注册的businessId,
 * 否则请按场景传入对应businessId
 * 账号注销场景：1100100014
 * 账号注册登录场景：1100100012
 * 登录状态下绑定手机号邮箱场景：1100100015
 * 登录状态下修改密码场景：1100100016
 * @param tel
 * @param args
 * @return {Promise<any>}
 */
export function sendByTel({ tel, ...args }) {
  return new Promise((resolve, reject) => {
    lpLogin.sendCaptchaRequest({
      requestType: 'getTelCode',
      requestData: {
        tel,
        ...args,
      },
      success({ flag, data, ...err }) {
        if (flag === 1) {
          resolve(data);
        } else {
          reject(err || {});
        }
      },
      cancel() {
        reject({});
      },
      error({ type, err: msg }) {
        reject({ type, msg });
      },
    });
  });
}

export function checkLogin(login) {
  return new Promise((resolve, reject) => {
    lpLogin.sendCaptchaRequest({
      requestType: 'checkLogin',
      requestData: { login },
      success({ flag, data, ...err }) {
        flag === 1 ? resolve(data) : reject(err || {});
      },
      cancel() {
        reject({});
      },
      error({ type, err: msg }) {
        reject({ type, msg });
      },
    });
  });
}

/**
 * 给当前用户的手机发送验证码，忽略验证状态【ALL】（账号设置页面）
 * @param args
 * @return {Promise<any>}
 * sendToUserPhone->sendToUserPhone
 */
export function getTelVerificationCode({ ...args }) {
  return new Promise((resolve, reject) => {
    lpLogin.sendCaptchaRequest({
      requestType: 'getTelVerificationCode',
      requestData: {...args },
      success({ flag, data, ...err }) {
        if (flag === 1) {
          resolve(data);
        } else {
          reject(err || {});
        }
      },
      cancel() {
        reject({});
      },
      error({ type, err: msg }) {
        reject({ type, msg });
      },
    });
  });
}
/**
 * 给当前用户已验证通过的手机发送验证码【ALL】（账号设置页面）
 * @param args
 * @return {Promise<any>}
 */
export function getTelCodeByOnline({ ...args }) {
  return new Promise((resolve, reject) => {
    lpLogin.sendRequest({
      requestType: 'getTelCodeByOnline',
      requestData: {...args },
      success({ flag, data, ...err }) {
        if (flag === 1) {
          resolve(data);
        } else {
          reject(err || {});
        }
      },
      cancel() {
        reject({});
      },
      error({ type, err: msg }) {
        reject({ type, msg });
      },
    });
  });
}
// 验证手机号
export function verificationTel({ smsCode, ...args }) {
  return new Promise((resolve, reject) => {
    lpLogin.sendRequest({
      requestType: 'verificationTel',
      requestData: {smsCode, ...args },
      success({ flag, data, ...err }) {
        if (flag === 1) {
          resolve(data);
        } else {
          reject(err || {});
        }
      },
      cancel() {
        reject({});
      },
      error({ type, err: msg }) {
        reject({ type, msg });
      },
    });
  });
}
// 获取用户登陆名
export function getLogin({ ...args }) {
  return new Promise((resolve, reject) => {
    lpLogin.sendRequest({
      requestType: 'getLogin',
      requestData: {...args },
      success({ flag, data, ...err }) {
        if (flag === 1) {
          resolve(data);
        } else {
          reject(err || {});
        }
      },
      cancel() {
        reject({});
      },
      error({ type, err: msg }) {
        reject({ type, msg });
      },
    });
  });
}
// 获取绑定邮箱和手机号
export function getBindMobileAndEmail({ ...args }) {
  return new Promise((resolve, reject) => {
    lpLogin.sendRequest({
      requestType: 'getBindMobileAndEmail',
      requestData: {...args },
      success({ flag, data, ...err }) {
        if (flag === 1) {
          resolve(data);
        } else {
          reject(err || {});
        }
      },
      cancel() {
        reject({});
      },
      error({ type, err: msg }) {
        reject({ type, msg });
      },
    });
  });
}
// 短信修改密码
export function smsModifyPwd({ pwd, smsCode, ...args }) {
  return new Promise((resolve, reject) => {
    lpLogin.sendRequest({
      requestType: 'smsModifyPwd',
      requestData: {pwd, smsCode, ...args },
      success({ flag, data, ...err }) {
        if (flag === 1) {
          resolve(data);
        } else {
          reject(err || {});
        }
      },
      cancel() {
        reject({});
      },
      error({ type, err: msg }) {
        reject({ type, msg });
      },
    });
  });
}
// 绑定未注册（未占用）手机号
export function bindTelWithUnReg({ tel, smsCode, ...args }) {
  return new Promise((resolve, reject) => {
    lpLogin.sendRequest({
      requestType: 'bindTelWithUnReg',
      requestData: {tel, smsCode, ...args },
      success({ flag, data, ...err }) {
        if (flag === 1) {
          resolve(data);
        } else {
          reject(err || {});
        }
      },
      cancel() {
        reject({});
      },
      error({ type, err: msg }) {
        reject({ type, msg });
      },
    });
  });
}
// 绑定手机号【APP/PC】
export function bindUniqueMobile({ tel, smsCode, ...args }) {
  return new Promise((resolve, reject) => {
    lpLogin.sendRequest({
      requestType: 'bindUniqueMobile',
      requestData: {tel, smsCode, ...args },
      success({ flag, data, ...err }) {
        if (flag === 1) {
          resolve(data);
        } else {
          reject(err || {});
        }
      },
      cancel() {
        reject({});
      },
      error({ type, err: msg }) {
        reject({ type, msg });
      },
    });
  });
}
// 不唯一绑定手机号
export function bindMobileForNormal({ tel, smsCode, ...args }) {
  return new Promise((resolve, reject) => {
    lpLogin.sendRequest({
      requestType: 'bindMobileForNormal',
      requestData: {tel, smsCode, ...args },
      success({ flag, data, ...err }) {
        if (flag === 1) {
          resolve(data);
        } else {
          reject(err || {});
        }
      },
      cancel() {
        reject({});
      },
      error({ type, err: msg }) {
        reject({ type, msg });
      },
    });
  });
}
// 判断tel，是否和当前登陆用户的手机号一致（账号设置-更改手机号）
export function checkOnlineTel({ tel, ...args }) {
  return new Promise((resolve, reject) => {
    lpLogin.sendRequest({
      requestType: 'checkOnlineTel',
      requestData: {tel, ...args },
      success({ flag, data, ...err }) {
        if (flag === 1) {
          resolve(data);
        } else {
          reject(err || {});
        }
      },
      cancel() {
        reject({});
      },
      error({ type, err: msg }) {
        reject({ type, msg });
      },
    });
  });
}
// 给手机号发送短信验证码【ALL】(账号设置-更改手机号)
export function sendByTelCheckToken({ tel, token, ...args }) {
  return new Promise((resolve, reject) => {
    lpLogin.sendCaptchaRequest({
      requestType: 'sendByTelCheckToken',
      requestData: {tel, token, ...args },
      success({ flag, data, ...err }) {
        if (flag === 1) {
          resolve(data);
        } else {
          reject(err || {});
        }
      },
      cancel() {
        reject({});
      },
      error({ type, err: msg }) {
        reject({ type, msg });
      },
    });
  });
}

export function loginByUserSignature({ userSignature, ...args }) {
  // 根据签名获取到加星的手机号
  return new Promise((resolve, reject) => {
    lpLogin.sendRequest({
      requestType: 'getLoginByUserSignature',
      requestData: {
        userSignature, // 必填，用户签名
        ...args,
      },
      success({ flag, data, ...err }) {
        flag === 1 ? resolve(data) : reject(err || {});
      },
      cancel() {
        reject({});
      },
      error({ type, err: msg }) {
        reject({ type, msg });
      },
    });
  });
}

export function sendSmsCodeByUserSignature({ userSignature, ...args }) {
  return new Promise((resolve, reject) => {
    lpLogin.sendCaptchaRequest({
      requestType: 'sendSmsCodeByUserSignature',
      requestData: {
        userSignature, // 必填
        businessId: '1100100011', // 必填，需要单独申请，请联系覃岭
        ...args,
      },
      success({ flag, data, ...err }) {
        flag === 1 ? resolve(data) : reject(err);
      },
      cancel() {
        reject({});
      },
      error({ type, err: msg }) {
        reject({ type, msg });
      },
    });
  });
}


export function formatParams($form, options = {}) {
  return $form && $form
    .serializeArray()
    .reduce((o, { name, value } = {}) => {
      o[name] = value;
      return o;
    }, options);
}

// 绑定邮箱
export function bindEmailWithUnReg({email, emailCode, ...args}){
  return new Promise((resolve, reject) => {
    lpLogin.sendRequest({
      requestType: 'bindEmailWithUnReg',
      requestData: {
        email,
        emailCode,
        ...args
      },
      success({ flag, data, ...err }) {
        flag === 1 ? resolve(data) : reject(err);
      },
      cancel() {
        reject({});
      },
      error({ type, err: msg }) {
        reject({ type, msg });
      },
    })
  })
}

// 获取邮箱验证码
export function getEmailCode({email,...args}){
  return new Promise((resolve, reject) => {
    lpLogin.sendCaptchaRequest({
      requestType: 'getEmailCode',
      requestData: { email, ...args },
      success({ flag, data, ...err }) {
        flag === 1 ? resolve(data) : reject(err);
      },
      cancel() {
        reject({});
      },
      error({ type, err: msg }) {
        reject({ type, msg });
      },
    })
  })
}

// 获取验证邮箱验证码
export function getEmailVerificationCode({...args}){
  return new Promise((resolve, reject) => {
    lpLogin.sendCaptchaRequest({
      requestType: 'getEmailVerificationCode',
      requestData: { ...args },
      success({ flag, data, ...err }) {
        flag === 1 ? resolve(data) : reject(err);
      },
      cancel() {
        reject({});
      },
      error({ type, err: msg }) {
        reject({ type, msg });
      },
    })
  })
}

// 验证邮箱
export function verificationEmail({emailCode, ...args}){
  return new Promise((resolve, reject) => {
    lpLogin.sendRequest({
      requestType: 'verificationEmail',
      requestData: { emailCode, ...args },
      success({ flag, data, ...err }) {
        flag === 1 ? resolve(data) : reject(err);
      },
      cancel() {
        reject({});
      },
      error({ type, err: msg }) {
        reject({ type, msg });
      },
    })
  }) 
}